module.exports = __webpack_public_path__ + "img/feature_buy_ph.5cf88669.png";